import { useEffect, useMemo, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';

export const useDimensions = () => {
  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  };

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  const isMobileSE = useMemo(() => isMobileOnly && windowDimensions.width <= 320, [windowDimensions.width, windowDimensions.height]);

  const isIPhoneSEorSmaller = useMemo(
    () => isMobileOnly && windowDimensions.height <= 375,
    [windowDimensions.width, windowDimensions.height],
  );

  const isMobileOrPad = useMemo(() => (isMobileOnly ? true : windowDimensions.width < 1024 ? true : false), [windowDimensions.width]);

  // PC screen size checks
  const isSmallPC = useMemo(() => windowDimensions.width >= 1024 && windowDimensions.width < 1440, [windowDimensions.width]);

  const isMediumPC = useMemo(() => windowDimensions.width >= 1440 && windowDimensions.width < 1920, [windowDimensions.width]);

  const isLargePC = useMemo(() => windowDimensions.width >= 1920, [windowDimensions.width]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    width: windowDimensions.width,
    height: windowDimensions.height,
    isMobileSE,
    isMobileOrPad,
    isIPhoneSEorSmaller,
    isSmallPC,
    isMediumPC,
    isLargePC,
  };
};
